import React, { FC, ComponentPropsWithoutRef } from 'react'
import { Box } from '@mui/material'


export const ContentWrapper:FC<ComponentPropsWithoutRef<'div'>> = ({ children, ...rest }) => <Box { ...rest }>{ children }</Box>
